import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_SpendAllocationRuleItemRow,
    WB_SpendAllocationRuleRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbSpendAllocationRule} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Spend_Allocation_Rule, esWB_Spend_Allocation_Rule_Item
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


export class SpendAllocationRuleBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_SpendAllocationRule: WB_SpendAllocationRuleRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New SpendAllocationRule'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_SpendAllocationRule = null;
    }

    get WB_SpendAllocationRule(): WB_SpendAllocationRuleRow
    {
        return this.drWB_SpendAllocationRule;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating SpendAllocationRule");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new SpendAllocationRule.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Spend_Allocation_Rule)
                .then((newSpendAllocationRuleRow: WB_SpendAllocationRuleRow)=> {
                    newSpendAllocationRuleRow.setDefaults()
                    self.drWB_SpendAllocationRule = newSpendAllocationRuleRow;
                    self.drWB_SpendAllocationRule.setDefaults()
                    self.dbContext.add(esWB_Spend_Allocation_Rule, newSpendAllocationRuleRow)
                    self.Identity.setAll(self.WB_SpendAllocationRule.cif.WB_SPENDRL_ID, self.WB_SpendAllocationRule.cif.SPEND_RULE_ID, self.WB_SpendAllocationRule.cif.SPEND_RULE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_SpendAllocationRule, 'WB_SPENDRL_ID','SPEND_RULE_ID','SPEND_RULE_NAME')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading SpendAllocationRule (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "SpendAllocationRule already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new SpendAllocationRule.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Spend_Allocation_Rule,  anId)
                .then(function (aSpendAllocationRuleRow){

                    if(_.isEmpty(aSpendAllocationRuleRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_SpendAllocationRule = aSpendAllocationRuleRow;
                    self.Identity.setAll(self.WB_SpendAllocationRule.cif.WB_SPENDRL_ID, self.WB_SpendAllocationRule.cif.WB_SPENDRL_ID, self.WB_SpendAllocationRule.cif.SPEND_RULE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_SpendAllocationRule, 'WB_SPENDRL_ID','SPEND_RULE_ID','SPEND_RULE_NAME')

                    // TODO, add in additional child relationships.
                    return (self.drWB_SpendAllocationRule.loadRelations([esWB_Spend_Allocation_Rule_Item],
                       self.LoadOptions));
                })
                .then((aSpendAllocationRuleRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_SpendAllocationRule.cif.SPEND_RULE_NAME + "(" + self.WB_SpendAllocationRule.cif.WB_SPENDRL_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate SpendAllocationRule.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbSpendAllocationRule = <IwbSpendAllocationRule>self.drWB_SpendAllocationRule;
        this.SaveProgressProvider.start("Saving " + wbSpendAllocationRule.SPEND_RULE_NAME + "(" + wbSpendAllocationRule.WB_SPENDRL_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save SpendAllocationRule.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_Spend_Allocation_Rule, self.drWB_SpendAllocationRule,{})
                .then((ignored) => {
                    return saveFunction(esWB_Spend_Allocation_Rule_Item, self.drWB_SpendAllocationRule.WB_SpendAllocationRuleItemRows,{})
                })
                .then((ignored) => {

                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbSpendAllocationRule = <IwbSpendAllocationRule>self.drWB_SpendAllocationRule;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbSpendAllocationRule.SPEND_RULE_NAME + "(" + wbSpendAllocationRule.WB_SPENDRL_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the SpendAllocationRule

            // 2. If Valid, mark all the records for deletion.
            self.drWB_SpendAllocationRule.markDeleted()
            _.forEach(self.drWB_SpendAllocationRule.WB_SpendAllocationRuleItemRows, (aRow) => {
                if(aRow && aRow.isActive){ aRow.markDeleted() }
            })

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //---------ITEM------------------------------------------------

//<editor-fold desc = "Spend Allocation Rule Item Operations">

    addSpendAllocationRuleItem(options: any): Promise<SpendAllocationRuleBO> {

        const self = this;
        return new Promise<SpendAllocationRuleBO>((resolve, error) => {

            // create new records
            return self.dbContext.createRecordWithKey(esWB_Spend_Allocation_Rule_Item)

                .then((aNewRow: WB_SpendAllocationRuleItemRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_SPENDRL_ID = self.drWB_SpendAllocationRule.cif.WB_SPENDRL_ID
                    self.dbContext.add(esWB_Spend_Allocation_Rule_Item, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })

        })

    }


    removeSpendAllocationRuleItem(aWB_SPENDRLR_ID: number, options: any): Promise<SpendAllocationRuleBO> {
        var self = this

        return new Promise<SpendAllocationRuleBO>((resolve, error) => {

            _.forEach(self.drWB_SpendAllocationRule.WB_SpendAllocationRuleItemRows, (aSpendAllocationRuleItemRow: WB_SpendAllocationRuleItemRow) => {
                if (aSpendAllocationRuleItemRow.isActive && aSpendAllocationRuleItemRow.cif.WB_SPENDRLR_ID == aWB_SPENDRLR_ID) {
                    aSpendAllocationRuleItemRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //---------ITEM------------------------------------------------

//<editor-fold desc = "Spend Allocation Rule Item Operations">

};
PAEnvironment.registerBusinessObjectClass( SpendAllocationRuleBO , "SpendAllocationRuleBO", "Spend Allocation Rule")